import $ from 'jquery';
import 'slick-carousel';

export default function about() {
	const responsiveSettings = [
		{
			breakpoint: 980,
			settings: {
				slidesToShow:1,
				slidesToScroll:1,
			}
		}
	];
	$('.history-slider').slick({
		slidesToShow:2,
		slidesToScroll:2,
		arrows:false,
		asNavFor: '.history-slider__nav',
		responsive: responsiveSettings

	});

	$('.history-slider__nav').slick({
		slidesToShow: 2,
		slidesToScroll:2,
		asNavFor: '.history-slider',
		dots: true,
		focusOnSelect: true,
		responsive: responsiveSettings
	});


	const togglePeopleBtn = document.querySelector('button.toggle-more-people')
	if (togglePeopleBtn) {
		togglePeopleBtn.addEventListener('click', function() {
			this.innerText = (this.innerText === 'View more') ? 'View less' : 'View more';
			$('.our-people__item--show-more').toggleClass('is-hidden');
		})
	}


	window.isTouch = false;
	window.addEventListener('touchstart', function onFirstTouch() {
		window.isTouch = true
		$('body').addClass('is-touch');
		// we only need to know once that a human touched the screen, so we can stop listening now
		window.removeEventListener('touchstart', onFirstTouch, false);
	}, false);

	$('.our-people__item.has-bio').click(function() {
		if (window.isTouch) {
			if ($(this).hasClass('show-bio')) {
				return $(this).removeClass('show-bio');
			}
			$('.our-people__item.has-bio').removeClass('show-bio');
			$(this).toggleClass('show-bio');
		}
	});

}
